import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onCompleted"],
    _excluded2 = ["fetchMore"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from '@apollo/client';
import { absurd, flow } from 'fp-ts/function';
import { useApolloResult } from '../use-apollo-result';
export var makeApiError = function makeApiError(errors) {
  return {
    _tag: 'api',
    errors: errors
  };
};
export var makeApolloError = function makeApolloError(error) {
  return {
    _tag: 'apollo',
    error: error
  };
};
export var makeDecodeError = function makeDecodeError(errors) {
  return {
    _tag: 'decoding',
    errors: errors
  };
};
export var foldQueryError = function foldQueryError(onApollo, onDecodeError, onApiError) {
  return function (queryError) {
    if (queryError._tag === 'apollo') return onApollo(queryError.error);
    if (queryError._tag === 'decoding') return onDecodeError(queryError.errors);
    if (queryError._tag === 'api') return onApiError(queryError.errors);
    return absurd(queryError);
  };
};
export function makeExtendedDecodedQuery(query, output, input) {
  return Object.assign(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onCompleted = _ref.onCompleted,
        options = _objectWithoutProperties(_ref, _excluded);

    var _useQuery = useQuery(query, _objectSpread({
      onCompleted: onCompleted === undefined ? undefined : flow(output.decode, onCompleted)
    }, options)),
        fetchMore = _useQuery.fetchMore,
        queryResult = _objectWithoutProperties(_useQuery, _excluded2);

    return {
      result: useApolloResult(_objectSpread(_objectSpread({}, queryResult), {}, {
        output: output
      })),
      fetchMore: fetchMore
    };
  }, _objectSpread({
    document: query,
    output: output
  }, input ? {
    input: input
  } : {}));
}